import app from 'flarum/forum/app';
import AboutPage from './components/AboutPage';

app.initializers.add('tf-about', () => {
  // 注册 about 路由
  app.routes.about = { path: '/about', component: AboutPage };
});

